module.exports = __webpack_public_path__ + "static/img/6.04e4761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/6.jpg
// module id = 0Abr
// module chunks = 1